

















































import { computed, defineComponent, nextTick, onMounted, ref, toRef, watch } from '@nuxtjs/composition-api';
import type { Swiper } from 'swiper';
import { useProductContext } from '~/features/productContext';

export default defineComponent({
  name: 'ProductPageViewSlider',
  props: {
    items: {
      type: Array,
      required: true,
    },
    arrows: {
      type: Boolean,
      default: true,
    },
    activeImage: {
      type: Number,
      default: 0,
    },
    isProductModal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const swiperRefGallery = ref(null);
    const isSliderLoaded = ref(false);
    const swiperInstance = ref<Swiper>();
    const items = toRef(props, 'items');
    const { product } = useProductContext();

    onMounted(async () => {
      const { default: Swiper, Navigation } = await import('swiper');
      Swiper.use([Navigation]);
      // @ts-ignore
      await import('swiper/swiper-bundle.css');

      isSliderLoaded.value = true;

      emit('sliderLoaded');

      await nextTick();

      swiperInstance.value = new Swiper(swiperRefGallery.value || '', {
        slidesPerView: 1,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        // breakpoints: {
        //   '675': {
        //     slidesPerView: 1,
        //     spaceBetween: 0,
        //     slidesOffsetBefore: 1,
        //   },
        //   '767': {
        //     slidesPerView: 1,
        //     spaceBetween: 20,
        //     slidesOffsetBefore: 0,
        //   },
        //   '1024': {
        //     slidesPerView: 1,
        //     spaceBetween: 20,
        //     slidesOffsetBefore: 0,
        //   },
        // },
        // Navigation arrows
        navigation: props.arrows
          ? {
              nextEl: '.gallery-next',
              prevEl: '.gallery-prev',
            }
          : undefined,
      });

      swiperInstance?.value.on('slideChange', () => {
        emit('slideChange', swiperInstance?.value?.activeIndex);
      });
      watch(items, () => {
        swiperInstance?.value?.updateSlides();
      });
    });

    watch(
      () => props.activeImage,
      activeIndex => {
        if (!swiperInstance?.value) return;

        swiperInstance?.value.slideTo(activeIndex, 0);
      }
    );

    const discount = computed(() => {
      if (!product.value?.priceBefore) {
        return 0;
      }

      return (product.value?.priceBefore - product.value.price) / product.value.priceBefore;
    });

    return {
      swiperRefGallery,
      swiperInstance,
      isSliderLoaded,
      product,
      discount,
    };
  },
});
